// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dropdown[data-v-4b343fe8]{display:contents}", ""]);
// Exports
module.exports = exports;
